"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createKey = function (e) { return e.audience + "::" + e.scope; };
var getExpirationTimeoutInMilliseconds = function (expiresIn, exp) {
    var expTime = (new Date(exp * 1000).getTime() - new Date().getTime()) / 1000;
    return Math.min(expiresIn, expTime) * 1000 * 0.8;
};
var Cache = /** @class */ (function () {
    function Cache() {
        this.cache = {};
    }
    Cache.prototype.save = function (entry) {
        var key = createKey(entry);
        console.debug('Cache key set', key);
        this.cache[key] = entry;
        var timeout = getExpirationTimeoutInMilliseconds(entry.expiresIn, entry.decodedToken.expiredAt());
        //setTimeout(() => {
        //	delete this.cache[key];
        //}, timeout);
    };
    Cache.prototype.get = function (key) {
        console.debug('Cache key get', key);
        return this.cache[createKey(key)];
    };
    return Cache;
}());
exports.default = Cache;
